import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { getRequest } from '../../helpers/apiHandler';
import { formatCurrency, formatWithoutCurrency } from '../../helpers/helperFunction';
import './_managerTransferCredits.scss';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const CreditTransferHistory = () => {
  const { access_token, user } = useSelector((state) => state.auth);
  const [transferHistoryData, setTransferHistoryData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState('');

  const getLinkedAccountCards = () => {
    const data = {
      headers: { Authorization: access_token.token },
    };
    getRequest('/admin/credit-transfer-history', data, (res) => {
      if (res.success) {
        const result = res.data;
        setTransferHistoryData(result.transfer_history);
        setFilteredData(result.transfer_history);
      }
    });
  };

  const columns = [
    {
      name: 'Date',
      width: '200px',
      sortable: true,
      selector: (row) => row.date,
    },
    {
      name: white_label_perkeso ? 'Credit Amount' : 'Amount',
      width: '200px',
      sortable: true,
      selector: (row) =>
        white_label_perkeso
          ? formatWithoutCurrency(row.amount, 0, 0)
          : formatCurrency(user?.currency?.iso3, row.amount, 2),
    },
    {
      name: 'From Account',
      sortable: true,
      selector: (row) => row.from_account,
    },
    {
      name: 'To Account',
      sortable: true,
      selector: (row) => row.to_account,
    },
  ];

  const onSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearch(searchValue);

    const filtered = transferHistoryData.filter(
      (item) =>
        item.from_account.toLowerCase().includes(searchValue) ||
        item.to_account.toLowerCase().includes(searchValue)
    );
    setFilteredData(filtered);
  };

  useEffect(() => {
    getLinkedAccountCards();
  }, []);

  return (
    <div className="CreditManagement">
      <div className="page-heading admin-heading">
        <div className="container-left" style={{ marginBottom: '32px', width: '300px' }}>
          <div className="page-title">Credit Transfer History</div>
        </div>
        <div className="container-right mt-0"></div>
        <InputGroup className="datatable-search search-input">
          <InputGroup.Append>
            <InputGroup.Text>
              <img alt="..." src={searchIcon} />
            </InputGroup.Text>
          </InputGroup.Append>
          <Form.Control
            placeholder="Search..."
            name="search"
            value={search}
            onChange={onSearch}
            className="search-form"
          />
        </InputGroup>
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
        pagination
      />
    </div>
  );
};

export default CreditTransferHistory;
